import React from "react";
import style from "./about.module.css";
import axios from "axios";
import { useEffect, useState } from "react";
import {
  API_AUTH_PASSWORD,
  API_AUTH_USERNAME,
  API_BASE_URL,
  ADMIN_ID,
} from "../../Constant/Global";
import { Helmet } from "react-helmet-async";

import Loader from "../../components/loader/Loader";
import AOS from "aos";
import "aos/dist/aos.css";

const About = () => {
  const isSpecificPage = false;

  const [aboutData, setAboutData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    AOS.init({
      offset: 200,
    });
  }, []);

  // about api

  const handleAboutData = async () => {
    try {
      const finalData = { admin_id: ADMIN_ID };
      // console.log("finalData", finalData);
      const response = await axios.post(API_BASE_URL + "web/about", finalData, {
        auth: {
          username: API_AUTH_USERNAME,
          password: API_AUTH_PASSWORD,
        },
      });
      // console.log("about response", response.data.data);
      setIsLoading(false);
      setAboutData(response.data.data);
    } catch (error) {
      console.log(error.response);
    }
  };

  useEffect(() => {
    handleAboutData();
  }, []);

  return (
    <>
      <Helmet>
        {isSpecificPage && (
          <meta
            name="viewport"
            content="width=device-width, initial-scale=0.5"
          />
        )}
        <title>ग्रामपंचायत | आमचे ध्येय</title>
      </Helmet>
      {isLoading ? (
        <Loader />
      ) : (
        <div className={`container-fluid ${style.about_container_fluid}`}>
          {/* purpose row */}
          <div className={`row ${style.purpose_row}`}>
            <header className={`${style.about_top_common_title_sec}`}>
              <span className={`${style.about_c_span_title}`}>Purpose</span>
              <h5 className={`${style.about_c_heading_title}`}>उद्देश</h5>
            </header>
            {aboutData?.purpose?.map((ele) => {
              return (
                <div
                  key={ele.id}
                  data-aos="fade-up"
                  data-aos-duration="1500"
                  className={`col-lg-6 ${style.purpose_col_second}`}
                >
                  <div className={`${style.purpose_right_col}`}>
                    <div className={`${style.purpose_right_img_title_sec}`}>
                      <img
                        src={require("../../assets/images/about/purpose-icon.png")}
                        alt="about"
                        className="img-fluid"
                        loading="lazy"
                      />
                      <p className={`${style.purpose_right_img_title}`}>
                        {ele.title}
                      </p>
                    </div>
                    <p
                      className={`${style.p_right_sec_para}`}
                      dangerouslySetInnerHTML={{
                        __html: ele.description,
                      }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
          {/* our goal row */}
          <div className={`row ${style.our_goal_row}`}>
            <header className={`${style.about_top_common_title_sec}`}>
              <span className={`${style.about_c_span_title}`}>Our goal</span>
              <h5 className={`${style.about_c_heading_title}`}>आमचे ध्येय</h5>
            </header>
            <div
              data-aos="fade-right"
              data-aos-duration="1500"
              className={`col-lg-7 ${style.our_goal_first_col}`}
            >
              <div className={`${style.our_goal_left_sec}`}>
                <div
                  className={`${style.our_goal_sub_sec}`}
                  dangerouslySetInnerHTML={{
                    __html: aboutData?.our_goal?.description1,
                  }}
                ></div>
              </div>
            </div>
            <div
              data-aos="fade-left"
              data-aos-duration="1500"
              className={`col-lg-5 ${style.our_goal_second_col}`}
            >
              <div className={`${style.our_goal_right_sec}`}>
                <div className={`${style.goal_right_img_sec}`}>
                  <img
                    src={aboutData?.our_goal?.image1}
                    alt="goal"
                    className="img-fluid"
                    loading="lazy"
                  />
                  <img
                    src={aboutData?.our_goal?.image2}
                    alt="goal"
                    className="img-fluid"
                    loading="lazy"
                  />
                </div>
                <p
                  className={`${style.goal_right_para}`}
                  dangerouslySetInnerHTML={{
                    __html: aboutData?.our_goal?.description2,
                  }}
                />
                {/* <div className={`${style.our_goal_right_color_boxes}`}>
                  <div className={`${style.goal_blue_box}`}>
                    <span className={`${style.goal_blue_box_text}`}>
                      ब्लिचिंग पावडर धुरळताना किंवा मातीवर फवारताना ती
                      काळजीपूर्वक हाताळावी
                    </span>
                  </div>
                  <div className={`${style.goal_yellow_box}`}>
                    <span className={`${style.goal_yellow_box_text}`}>
                      ब्लिचिंग पावडर धुरळताना किंवा मातीवर फवारताना ती
                      काळजीपूर्वक हाताळावी
                    </span>
                  </div>
                  <div className={`${style.goal_violate_box}`}>
                    <span className={`${style.goal_violate_box_text}`}>
                      ब्लिचिंग पावडर धुरळताना किंवा मातीवर फवारताना ती
                      काळजीपूर्वक हाताळावी
                    </span>
                  </div>
                </div>
                <div className={`${style.our_goal_right_color_boxes}`}>
                  <div className={`${style.goal_violate_box}`}>
                    <span className={`${style.goal_violate_box_text}`}>
                      ब्लिचिंग पावडर धुरळताना किंवा मातीवर फवारताना ती
                      काळजीपूर्वक हाताळावी
                    </span>
                  </div>
                  <div className={`${style.goal_yellow_box}`}>
                    <span className={`${style.goal_yellow_box_text}`}>
                      ब्लिचिंग पावडर धुरळताना किंवा मातीवर फवारताना ती
                      काळजीपूर्वक हाताळावी
                    </span>
                  </div>
                  <div className={`${style.goal_blue_box}`}>
                    <span className={`${style.goal_blue_box_text}`}>
                      ब्लिचिंग पावडर धुरळताना किंवा मातीवर फवारताना ती
                      काळजीपूर्वक हाताळावी
                    </span>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default About;
